import React from "react";

import {
	faLocationCrosshairs,
	faMagnifyingGlassMinus,
	faMagnifyingGlassPlus,
} from "@performyard/fontawesome/pro-regular-svg-icons";
import { ButtonIcon, Tooltip } from "@performyard/py-components";

import css from "../OrgChart.module.scss";

interface ZoomControlsProps {
	onZoomIn: () => void;
	onZoomOut: () => void;
	onCenter: () => void;
}

export function ZoomControls({ onZoomIn, onZoomOut, onCenter }: ZoomControlsProps) {
	return (
		<div data-interactive className={css.zoomControls}>
			<Tooltip content="Zoom in" asChild>
				<ButtonIcon
					variant="outline"
					color="neutral"
					size={32}
					icon={faMagnifyingGlassPlus}
					onClick={onZoomIn}
					aria-label="Zoom in"
				/>
			</Tooltip>
			<Tooltip content="Zoom out" asChild>
				<ButtonIcon
					variant="outline"
					color="neutral"
					size={32}
					icon={faMagnifyingGlassMinus}
					onClick={onZoomOut}
					aria-label="Zoom out"
				/>
			</Tooltip>
			<Tooltip content="Center chart" asChild>
				<ButtonIcon
					variant="outline"
					color="neutral"
					size={32}
					icon={faLocationCrosshairs}
					onClick={onCenter}
					aria-label="Center chart"
				/>
			</Tooltip>
		</div>
	);
}
